import { Component, OnInit } from '@angular/core';
import { AppStateService } from "@app/shared/services/app-state.service";
import { buyerSideMenuItem } from '@app/shared/constants/tech-buyer-side-menu';
import { AuthenticationService } from '@app/shared/services/authentication.service';
import { vendorSideMenuItem } from '@app/shared/constants/tech-vendor-side-menu';
import { analystSideMenuItem } from '@app/shared/constants/tech-analyst-menu';
import { staffSideMenuItem } from '@app/shared/constants/ecosystm-staff-menu';

declare var $: any;
@Component({
  selector: 'app-right-side-menu-bar',
  templateUrl: './right-side-menu-bar.component.html',
  styleUrls: ['./right-side-menu-bar.component.css']
})
export class RightSideMenuBarComponent implements OnInit {
  loggedIn = false;
  sideMenuItem: any = [];
  constructor(
    private authenticationService: AuthenticationService,
    private appState: AppStateService) {

  }

  ngOnInit() {
    this.getRole();
    this.appState.loggedIn.subscribe(
      (response: boolean) => {
        // Quick fix to resolve navbar issue
        const session = window.sessionStorage.getItem('userDetails');
        if (session && response) {
          this.loggedIn = response;
        } else {
          this.loggedIn = false;
        }
        if (this.loggedIn) {
          this.getRole();
        }
      },
      error => { }
    );
  }
  removeSession() {
    sessionStorage.removeItem('BC4Url');
    sessionStorage.removeItem('BC4Label');
    sessionStorage.removeItem('BC3Url');
    sessionStorage.removeItem('BC3Label');
    sessionStorage.removeItem('BC2Url');
    sessionStorage.removeItem('BC2Label');
  }

  getRole() {
    const userRole = this.authenticationService.getRole();
    if (userRole === "tech_buyer") {
      this.sideMenuItem = buyerSideMenuItem;
    } else if (userRole === "tech_vendor") {
      this.sideMenuItem = vendorSideMenuItem;
    } else if (userRole === "ecosystm_staff") {
      this.sideMenuItem = staffSideMenuItem;
    } else {
      this.sideMenuItem = analystSideMenuItem;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/right-side-menu-bar/right-side-menu-bar.component.ts